module.exports = __webpack_public_path__ + "static/plans-start-dr-2bd181d665df62273b2db25812047c46.png";